
import surface from '../../../img/surface.jpg';
import fullLogo from '../../../img/uh_logo_white.png';

import React, { Fragment } from 'react';
import {buttonCommon, outlineButton} from "../../common/elements/classNames"
import RouteLink from 'view/common/elements/routeLink';
import Header from './header';
import Separator from './separator';

const Landing = (props) => {
  
  const sectionClass='inline-block w-full lg:w-1/2';
  
  return ( 
    <Fragment>
      <Header/>
      <div className='bg-uhnavy px-5 min-h-screen lg:min-h-px'>
        <div className='flex flex-col lg:flex-row'>
          <div className={`${sectionClass} order-2 lg:order-1 text-center mb-60 mt-10 lg:mt-40`}>
            <img src={surface} className='w-10/12 table mx-auto'  alt={"UH Logo"}/>
          </div>
          <div className={`${sectionClass} text-white text-center order-1 lg:order-2 mt-20 text-lg`}>
            <div className='max-w-96 margin-auto hidden lg:table' style={{maxWidth:'200px',margin:'auto'}}>
              <img src={fullLogo} className='w-full'  alt={"UH Logo"}/>
            </div>
            <div className='text-2xl font-bold  mt-10'>Biomarker Risk Analytics</div>
            <div className='my-5'>
              <RouteLink
                  text="Life Insurance Portal"
                  href="/contactUs"
                  className={`${outlineButton} ${buttonCommon} w-60 lg:w-80`}
                />
            </div>
            {/* <div className='my-5 text-lg'>
              
              <RouteLink
                text="Life Insurance Portal"
                href="/"
                className={`font-white font-bold underline ml-5`}
              />
            </div> */}
            
            <div className='my-5'>
              convexity <Separator/> partial deltas <Separator/> relative entropy 
              <Separator/> crowding out effects <Separator/> hazard curvature
            </div> 
            <div className='my-5'>risk surfaces <Separator/> portfolio analytics <Separator/> API</div>
            <div className='my-5'>underwriting <Separator/> re-underwriting <Separator/> surveillance</div>
          </div>
          
        </div>
      </div>
    </Fragment>
  ) 
}

export default Landing;